export * from "./component.module";
export * from "./footer/footer.component";
export * from "./header/header.component";
export * from "./spinner/spinner.component";
export * from "./loading-placeholder/loading-placeholder.component";
export * from "./page-not-found/page-not-found.component";
export * from "./table/table.component";